module.exports = __webpack_public_path__ + "static/media/id_3.dd2a2643.jpg";